import { useContext, useEffect, useMemo } from 'react'
import { useParams, useNavigate } from "react-router-dom"

import { AppContext } from '/providers/app-context'

import PageWrapper from '/components/page-wrapper'
import Summary from '/components/templates/summary'
import Preview from '/components/templates/preview'

import HelpText from '/help/template-details'
import Menu from '/components/templates/template-nav-menu'

const TemplateDetails = () => {

  const { templateId } = useParams()
  const { loadingTemplates, templates } = useContext(AppContext)

  const template = useMemo(() => {return templates.filter(t => t.template_id === templateId)[0]}, [templates, templateId])

  const navigate = useNavigate()

  useEffect(() => {
   if (!loadingTemplates && !template) navigate("/templates")
  }, [loadingTemplates, template, navigate])

  const heading = useMemo(() => template ? `${template.name} ${template.archived ? " [archived]" : ""}` : "",[template])

  if (template) return (
    <PageWrapper title="Template Details" HelpText={HelpText} showWait heading={heading} menu={<Menu template={template} />}>
      <div className='flex flex-wrap gap-5 overflow-y-scroll w-screen h-full pb-10'>
        <Summary template={template}/>
        <Preview template={template}/>
      </div>
    </PageWrapper>
  )
}

export default TemplateDetails
